<template lang="pug">
.container
  .buttons
    button3d(@click="first()")
      icon(name="begin")
    button3d(@click="fprev()")
      icon(name="fp")
    button3d(@click="prev()")
      icon(name="prev")
    button3d(@click="next()")
      icon(name="next")
    button3d(@click="fnext()")
      icon(name="ff")
    button3d(@click="last()")
      icon(name="end")
  div(style="font-size: 3vw; color: black") {{ range }} / {{ items.length }}
  .grid
    .cell(v-for="i in 49", :style="{ backgroundColor: color(i) }")
      div {{ i }}
      div {{ Math.trunc((weights[i] || { f: 0 }).f) }}
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Icon from "@/components/Icon.vue";
import Button3d from "@/components/Button3d.vue";
import LottoGrid from "@/components/LottoGrid.vue";
export default {
  components: { Icon, Button3d, LottoGrid },
  data() {
    return {
      colors: [],
      weights: {},
      range: 0,
    };
  },
  computed: {
    ...mapGetters({
      items: "lotto/items",
    }),
  },
  methods: {
    ...mapActions({
      load: "lotto/load",
    }),
    first() {
      this.range = 1;
      this.heatMap(this.range);
    },
    fprev() {
      if (this.range > 10) this.range -= 10;
      else this.range = this.items.length - 1;
      this.heatMap(this.range);
    },
    prev() {
      if (this.range > 1) this.range--;
      else this.range = this.items.length - 1;
      this.heatMap(this.range);
    },
    next() {
      if (this.range < this.items.length - 1) this.range++;
      else this.range = 1;
      this.heatMap(this.range);
    },
    fnext() {
      if (this.range < this.items.length - 10) this.range += 10;
      else this.range = 1;
      this.heatMap(this.range);
    },
    last() {
      this.range = this.items.length - 1;
      this.heatMap(this.range);
    },
    color(i) {
      if (!this.weights) return "";
      return this.colors[Math.trunc((this.weights[i] || { p: 0, f: 0 }).p)];
    },
    interpolateColor(color1, color2, factor) {
      let c1 = color1.match(/\w\w/g).map((c) => parseInt(c, 16));
      let c2 = color2.match(/\w\w/g).map((c) => parseInt(c, 16));

      let r = Math.round(c1[0] + (c2[0] - c1[0]) * factor);
      let g = Math.round(c1[1] + (c2[1] - c1[1]) * factor);
      let b = Math.round(c1[2] + (c2[2] - c1[2]) * factor);

      return `#${r.toString(16).padStart(2, "0")}${g
        .toString(16)
        .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
    },
    generateGradientArray(steps) {
      let colors = ["#0000ff", "#00ff00", "#ffff00", "#ff0000"]; // Blau → Grün → Gelb → Rot
      let gradient = [];
      let segmentCount = steps / (colors.length - 1);

      for (let i = 0; i < colors.length - 1; i++) {
        for (let j = 0; j < segmentCount; j++) {
          let factor = j / segmentCount;
          gradient.push(
            this.interpolateColor(colors[i], colors[i + 1], factor)
          );
        }
      }
      return gradient.slice(0, steps);
    },
    heatMap(count) {
      const weights = {};
      for (let i = 1; i <= 49; i++) weights[i] = { f: 0, p: 0 };
      const draws = this.items.slice(-count);
      draws.forEach((d) => {
        d.drawNumbersCollection.forEach((n) => {
          weights[n] = weights[n] || { f: 0, p: 0 };
          weights[n].f++;
        });
      });
      let max = 0;
      let min = 9999999;
      Object.keys(weights).forEach((k) => {
        max = Math.max(weights[k].f, max);
        min = Math.min(weights[k].f, min);
      });
      console.log(min, max);
      Object.keys(weights).forEach(
        (k) => (weights[k].p = ((weights[k].f - min) * 100) / (max - min))
      );
      console.log(weights);
      this.weights = weights;
    },
    calculateLottoGaps(count) {
      const weights = {};
      for (let i = 1; i <= 49; i++) weights[i] = { f: 0, p: 0 };
      if (!this.items || this.items.length < 1) return null;
      console.log("--- 1", count, this.items.length);
      const draws = this.items.slice(0, -count);
      console.log("--- 2", this.items.length, draws);
      let lastSeen = Array(50).fill(null); // Index 1-49 für Lottozahlen
      let gaps = Array(50).fill(null);

      console.log("--- 3", draws.length);
      // Durch alle Ziehungen gehen (älteste zuerst)
      for (let i = draws.length - 1; i >= 0; i--) {
        const draw = draws[i];

        // Jede gezogene Zahl mit ihrem Datum speichern
        for (let num of draw.drawNumbersCollection) {
          lastSeen[num] = draw.drawDate;
        }
      }
      console.log("--- 4");
      const targetDate = new Date().getTime();
      // Berechnen, wie lange jede Zahl nicht gezogen wurde
      for (let i = 1; i <= 49; i++) {
        if (lastSeen[i]) {
            console.log(i, new Date(lastSeen[i]).toLocaleDateString())
          let diffDays = Math.floor(
            (targetDate - lastSeen[i]) / (1000 * 60 * 60 * 24)
          );
          gaps[i] = diffDays;
        } else {
          gaps[i] = 9999; // Falls eine Zahl nie vorkam
        }
      }
      console.log("--- 5", gaps);
      gaps.slice(1).forEach((g, ix) => {
        weights[ix+1] = { f: g, p: g };
      });
      console.log(weights);
      this.weights = weights;
    },
  },
  async mounted() {
    this.colors = this.generateGradientArray(101);
    await this.load();
    this.range = 1;
    // this.heatMap(this.range);
    console.log("calculateLottoGaps");
    this.calculateLottoGaps(this.range);
    // setInterval(() => {
    //   this.range++;
    //   if (this.range >= this.items.length) this.range = 1;
    //   this.heatMap(this.range);
    // }, 1000);
  },
};
</script>

<style lang="less" scoped>
.container {
  flex: 1 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  margin: 4vw 0;
}
.buttons {
  align-self: stretch;
  display: flex;
  justify-content: space-evenly;
}
.grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.grid .cell {
  width: 11vw;
  height: 11vw;
  font-size: 3vw;
  line-height: 5vw;
  color: black;
  border: 1px solid gray;
  margin: 1px;
}
</style>